import { v4 } from "uuid";
import { TransactionType } from "../../../contract/pam.js";
import { UserProfileViewModelKeysTypeName, UserProfileQueryFieldsTypeName } from "../../user-profile/constants.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap, map } from "../../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "redux-observable";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import { mapViewFilterToString } from "../../../redux-folder/view/utils.js";
class LoadP2PTransferBaseStrategy {
  _userProfileService;
  _mapper;
  _userProfileEntityType;
  constructor(userProfileService, mapper, userProfileEntityType) {
    this._userProfileService = userProfileService;
    this._mapper = mapper;
    this._userProfileEntityType = userProfileEntityType;
  }
  loadPlayers({ keys, loadData }) {
    const fields = this._mapper.map(
      keys,
      UserProfileViewModelKeysTypeName,
      UserProfileQueryFieldsTypeName
    );
    const filter = {
      uid: loadData.map((i) => i.uid).filter((u) => u).join(" "),
      size: loadData.length,
      page: 1
    };
    const request = {
      type: this._userProfileEntityType,
      fields,
      filter: mapViewFilterToString(filter, ["uid", "page", "size"])
    };
    return this._userProfileService.get(request).pipe(
      map(
        (value) => loadData.map((i) => {
          const id = v4();
          const userProfile = value?.responsePayload?.items?.find((j) => j.uid === i.uid);
          return {
            ...userProfile,
            id,
            serverId: id,
            uid: i.uid,
            amount: i.amount,
            transaction_type: TransactionType.P2PTransferCredit
          };
        })
      )
    );
  }
}
class LoadP2PTransferStrategy extends LoadP2PTransferBaseStrategy {
  process({ keys, uids }) {
    return this.loadPlayers({ keys, loadData: uids.map((i) => ({ uid: i, amount: 0 })) });
  }
}
class LoadP2PTransferViaFileStrategy extends LoadP2PTransferBaseStrategy {
  _templateFactory;
  constructor(userProfileService, mapper, userProfileEntityType, templateFactory) {
    super(userProfileService, mapper, userProfileEntityType);
    this._templateFactory = templateFactory;
  }
  process(request) {
    const parsedData = this._templateFactory.parseFile(request.filePayload);
    return parsedData.pipe(
      mergeMap((value) => {
        return this.loadPlayers({ keys: request.keys, loadData: value });
      })
    );
  }
}
export {
  LoadP2PTransferStrategy,
  LoadP2PTransferViaFileStrategy
};
//# sourceMappingURL=loadItemsStrategy.js.map
